import React, { useState, useRef } from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import AxiosInstance from './AxiosInstance';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import ToastNotification from "./ToastNotification";

const Account = () => {
  const [user, setUser] = useState({ password: "", confirmPassword: "" });
  const [showCriteria, setShowCriteria] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [passwordCriteria, setPasswordCriteria] = useState({
    length: false,
    upper: false,
    lower: false,
    number: false,
    special: false,
  });

  const toastRef = useRef(null);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const validatePassword = (password) => {
    setPasswordCriteria({
      length: password.length >= 8,
      upper: /[A-Z]/.test(password),
      lower: /[a-z]/.test(password),
      number: /[0-9]/.test(password),
      special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
    });
  };

  const isPasswordStrong = Object.values(passwordCriteria).every(Boolean);

  const handlePasswordUpdate = async (e) => {
    e.preventDefault();

    const userId = localStorage.getItem("employeeId");

    if (!user.password || !user.confirmPassword) {
      toastRef.current?.showToast("Please fill in both password fields.", "danger");
      return;
    }

    if (user.password !== user.confirmPassword) {
      toastRef.current?.showToast("Passwords do not match!", "danger");
      return;
    }

    if (!isPasswordStrong) {
      toastRef.current?.showToast("Password does not meet the required criteria.", "danger");
      return;
    }

    try {
      const response = await AxiosInstance.put(`common/update-password`, {
        user_id: userId,
        newPassword: user.password,
      });

      if (response.data.success) {
        toastRef.current?.showToast("Password updated successfully!", "success");
        window.location.reload();
      } else {
        toastRef.current?.showToast(response.data.message || "Password update failed.", "danger");
      }
    } catch (err) {
      toastRef.current?.showToast("Error updating password.", "danger");
    }
  };

  return (
    <div className="container mt-4">
      <form onSubmit={handlePasswordUpdate}>
        <div className="mb-3">
          <label className="form-label">Enter New Password:</label>
          <div className="input-group w-50">
            <input
              type={passwordVisible ? "text" : "password"}
              name="password"
              onFocus={() => setShowCriteria(true)}
              onBlur={() => setShowCriteria(false)}
              onChange={(e) => {
                const value = e.target.value;
                setUser({ ...user, password: value });
                validatePassword(value);
              }}
              className="form-control"
              placeholder="Enter your new password"
              value={user.password}
              required
            />
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={togglePasswordVisibility}
              style={{ borderLeft: "none" }}
            >
              {passwordVisible ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
        </div>

        {/* Password strength tips */}
        <div className="card-box">
              
        </div>
        {showCriteria && (
          <div className="mb-3 ms-1 card p-3">
            <ul className="list-unstyled small mb-0">
              <li className={passwordCriteria.length ? "text-success" : "text-danger"}>
                <i className={`bi ${passwordCriteria.length ? "bi-check2-circle" : "bi-x-circle"} me-2`}></i>
                At least 8 characters
              </li>
              <li className={passwordCriteria.upper ? "text-success" : "text-danger"}>
                <i className={`bi ${passwordCriteria.upper ? "bi-check2-circle" : "bi-x-circle"} me-2`}></i>
                At least one uppercase letter
              </li>
              <li className={passwordCriteria.lower ? "text-success" : "text-danger"}>
                <i className={`bi ${passwordCriteria.lower ? "bi-check2-circle" : "bi-x-circle"} me-2`}></i>
                At least one lowercase letter
              </li>
              <li className={passwordCriteria.number ? "text-success" : "text-danger"}>
                <i className={`bi ${passwordCriteria.number ? "bi-check2-circle" : "bi-x-circle"} me-2`}></i>
                At least one number
              </li>
              <li className={passwordCriteria.special ? "text-success" : "text-danger"}>
                <i className={`bi ${passwordCriteria.special ? "bi-check2-circle" : "bi-x-circle"} me-2`}></i>
                At least one special character
              </li>
            </ul>
          </div>
        )}
        <div className="mb-3">
          <label className="form-label">Re-enter Password:</label>
          <input
            type="password"
            name="confirmPassword"
            onChange={(e) => setUser({ ...user, confirmPassword: e.target.value })}
            className="form-control w-50"
            placeholder="Re-enter your password"
            value={user.confirmPassword}
            required
          />
        </div>

        <button type="submit" className="btn btn-secondary" disabled={!isPasswordStrong}>
          Update Password
        </button>
      </form>
      <ToastNotification ref={toastRef} />
    </div>
  );
};

export default Account;
